<template>
  <b-dropdown size="lg" variant="link" toggle-class="text-decoration-none" no-caret right class="header_menu_add_options">
    <template #button-content>
      <button class="no_btn add_vac_btn"><span class="mb_dn">Добавить</span><new-plus-white-svg/></button>
    </template>
    <b-dropdown-item-button @click.prevent="addProject">
      <add-project-svg/>
      <p>Проект</p>
      <span>Создать новый новый проект</span>
    </b-dropdown-item-button>
    <b-dropdown-item-button @click.prevent="$router.history.push('/create-vacancy')">
      <add-vac-svg/>
      <p>Вакансию</p>
      <span>Добавить новую вакансию</span>
    </b-dropdown-item-button>
    <b-dropdown-item-button v-b-modal.add-applicant-modal>
      <add-applicant-svg/>
      <p>Добавить кандидата</p>
      <span>Добавить кандидата вручную</span>
    </b-dropdown-item-button>
  </b-dropdown>
</template>

<script>
import ButtonDotted from "./common/button-dotted.vue";
import NewPlusWhiteSvg from "./common/svg/new-plus-white-svg.vue";
import AddProjectSvg from "./common/svg/add-project-svg.vue";
import AddVacSvg from "./common/svg/add-vac-svg.vue";
import AddApplicantSvg from "./common/svg/add-applicant-svg.vue";

export default {
  name: "header-menu-add-options",
  components: {AddApplicantSvg, AddVacSvg, AddProjectSvg, NewPlusWhiteSvg, ButtonDotted},
  methods: {
    addProject() {
      this.$store.commit('setFunction', {name: 'current_project', payload: null})
      this.$root.$emit('bv::show::modal', 'add-project-modal');
    },
  }
}
</script>

<style>
.header_menu_add_options > .dropdown-toggle {padding: 0;}
.header_menu_add_options .add_vac_btn.hidden {opacity: 0; visibility:hidden;}
.header_menu_add_options > .dropdown-toggle:focus {box-shadow: unset;}
.header_menu_add_options .add_vac_btn:hover {background: linear-gradient(180deg, #3FA9F5 0%, #017AFF 100%); border: 1px solid transparent;}
.header_menu_add_options .add_vac_btn > svg {margin-left: 12px;}
.header_menu_add_options .add_vac_btn {font-weight: 500; font-size: 14px; padding: 4px 8px 4px 16px;
  justify-content: space-between; color: #FFFFFF; border-radius: 4px; border: 1px solid #FFF; transition: 0.3s all ease;}
.header_menu_add_options li > .dropdown-item {display: grid; grid-template-columns: min-content 1fr; grid-gap: 4px 6px;}
.header_menu_add_options li > .dropdown-item > svg {grid-row: 1/3; grid-column: 1/2; align-self: center;}
.header_menu_add_options li > .dropdown-item > p {margin: 0; color: var(--System-Text, #253232); font-size: 16px;font-style: normal;font-weight: 400; line-height: 24px;}
.header_menu_add_options li > .dropdown-item > span {color: var(--System-Text-grey, #868C95); font-size: 12px; font-weight: 400; line-height: 16px;}
@media (max-width: 992px) {
  .header_menu_add_options .add_vac_btn > svg {margin-left: 0;}
  .header_menu_add_options .add_vac_btn {padding: 0; height: 24px; width: 24px; display: flex; align-items: center; justify-content: center;}
}
</style>
